var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSmsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3313 5.50876L7.10402 9.138L1.63657 7.31528C1.25493 7.1878 0.997818 6.82974 1.00001 6.42747C1.00224 6.02521 1.2623 5.66934 1.64541 5.54632L15.6238 1.04476C15.9561 0.937946 16.3208 1.02561 16.5676 1.27243C16.8144 1.51926 16.9021 1.88394 16.7953 2.21623L12.2937 16.1946C12.1707 16.5777 11.8148 16.8378 11.4126 16.84C11.0103 16.8422 10.6522 16.5851 10.5247 16.2035L8.69318 10.7095L12.3313 5.50876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSmsIcon);
export default __webpack_public_path__ + "static/media/send-sms-icon.a92338601896466dc351411ceeb75ff0.svg";
export { ForwardRef as ReactComponent };